import React from "react"
import { useSelector } from "react-redux"
import { RootState } from "../../store/store"

const Loader = () => {
  const isLoading = useSelector((state: RootState) => state.loader.isLoading)
  return (
    <>
      {isLoading && (
        <section className='custome-loader-section'>
          <div className='custome-loader'></div>
        </section>
      )}
    </>
  )
}

export default Loader
